import { Routes, Route } from "react-router-dom";
import App from "./App";
import { NotFoundPage } from "./components/404";
import FacilityDashboard from "./components/FacilityDashboard";
import { EditUser } from "./components/EditUser";
import { OpenLastViewed } from "./components/OpenLastViewed";
import Login from "./components/login";
import ResetPassword from "./components/resetPassword";
import Backups from "./components/Backups";
import Users from "./components/users";
import DailyReportPreview from "./components/DailyReportPreview";
import { useUser } from "./store";

export const AppRoutes = () => {
  const { authenticated, user } = useUser();

  return (
    <Routes>
      <Route path="/:group" element={<App />}>
        <Route path="login" element={<Login />} />
        {!authenticated ? (
          <>
            <Route path="reset-password/:token" element={<ResetPassword />} />
            <Route path="" element={<Login />} />
            <Route path="*" element={<Login />} />
          </>
        ) : (
          <>
            {user.type === "Admin" && (
              <>
                <Route path="users" element={<Users />} />
                <Route path="users/create" element={<EditUser />} />
                <Route path="users/:username" element={<EditUser />} />
                <Route path="daily-report-preview" element={<DailyReportPreview />} />
              </>
            )}
            <Route path=":facility" element={<OpenLastViewed />} />
            <Route path=":facility/:payer/backups" element={<Backups />} />
            <Route path=":facility/:payer" element={<FacilityDashboard />} />
            <Route path="" element={<OpenLastViewed />} />
            <Route path="*" element={<NotFoundPage />} />
          </>
        )}
      </Route>
      <Route path="" element={<NotFoundPage />} />
    </Routes>
  );
};
